import { action, computed, makeObservable, observable } from "mobx";

export type ViewModeType = "add" | "edit" | "read";

export class ViewMode {
    public _mode: ViewModeType = "read";
    constructor(initialMode?: ViewModeType) {
        makeObservable(this, {
            _mode: observable,

            addMode: action,
            editMode: action,
            readMode: action,

            isAddMode: computed,
            isEditMode: computed,
            isReadOnlyMode: computed,
        });

        switch (initialMode) {
            case "add":
                this.addMode();
                break;
            case "edit":
                this.editMode();
                break;
            case "read":
                this.readMode();
                break;
            default:
                this.readMode();
                break;
        }
    }
    public addMode() {
        this._mode = "add";
    }

    public editMode() {
        this._mode = "edit";
    }

    public readMode() {
        this._mode = "read";
    }

    public get isAddMode(): boolean {
        return this._mode === "add";
    }

    public get isEditMode(): boolean {
        return this._mode === "edit";
    }

    public get isReadOnlyMode(): boolean {
        return this._mode === "read";
    }
}
